import React from "react";
import { Outlet, NavLink, Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import Cart from "../Cart";
import arrowUp from "../../assets/arrow_up.svg";
import arrowDown from "../../assets/arrow_down.svg";
import LoadingComponent from "../LoadingComponent";
import { setMobileViewProperties } from "../../store/order.store";
import "./index.css";
import Edit from "../../assets/edit.svg";
import { useGetUserDetail } from "../../hooks";
import { resetUserStore } from "../../store";

function Main() {
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { orderPlaced } = useSelector((state) => state.order);

  const { isLoading: detailLoading } = useGetUserDetail(user, dispatch);
  const isPaymentPage = React.useMemo(
    () =>
      location.pathname.includes("choose-type") ||
      location.pathname.includes("payment"),
    [location.pathname]
  );

  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const paymentPage = React.useMemo(
    () => !location.pathname.includes("login"),
    [location.pathname]
  );
  const { mobileView } = useSelector((state) => state.order);

  const showdropDown = React.useMemo(
    () =>
      location.pathname.includes("choose-type") ||
      location.pathname.includes("payment") ||
      location.pathname.includes("address"),
    [location.pathname]
  );

  const handleChangeNumber = () => {
    dispatch(resetUserStore());
    return <Navigate to="/login" />;
  };

  if (detailLoading) return <LoadingComponent height="90vh" />;

  if (!user?.authToken && location.pathname !== "/login")
    return <Navigate to="/login" />;

  if (
    user?.authToken &&
    (location.pathname === "/login" || location.pathname === "/")
  )
    return <Navigate to="/address" />;

  return (
    <div className="checkout-flow">
      <div className="split left">
        {isMobile && (
          <div className="checkout-summary">
            <div className="checkout-left-section">
              <div className="left-section-heading">
                <h6>
                  {!!user?.shopifyDetails?.firstName &&
                    `${user?.shopifyDetails?.firstName}'s `}
                  Checkout Summary
                </h6>
                {!!user?.shopifyDetails?.email && (
                  <div className="text-color-red">
                    {user?.shopifyDetails?.email}
                  </div>
                )}
                {!!user?.details.phoneNumber && (
                  <div className="right-section">
                    <div>+91-{user?.details.phoneNumber}</div>
                    {!paymentPage ? (
                      <button
                        type="button"
                        aria-label="edit_button"
                        className="edit_button"
                        onClick={handleChangeNumber}
                      >
                        <img src={Edit} alt="" />
                      </button>
                    ) : (
                      <div>&nbsp;</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            {!showdropDown && (
              <div>
                <button
                  type="button"
                  className="order-detail"
                  onClick={() =>
                    dispatch(
                      setMobileViewProperties({ showOrderDetails: true })
                    )
                  }
                >
                  <div className="order-summary">
                    Order Summary
                    <span className="text-color-red">
                      Discounts can be applied at the last step
                    </span>
                  </div>
                  <span>
                    {mobileView?.showOrderDetails ? (
                      <img src={arrowUp} alt="down" />
                    ) : (
                      <img src={arrowDown} alt="up" />
                    )}
                  </span>
                </button>
              </div>
            )}
          </div>
        )}
        <div className="left-upper-section">
          {!isMobile && (
            <>
              <div
                className={`top ${user?.details.phoneNumber ? "content-space-between" : "content-center"}`}
              >
                <div className="left-section">
                  <div className="">
                    {!!user?.shopifyDetails?.firstName &&
                      `${user?.shopifyDetails?.firstName}'s `}
                    Checkout Summary
                  </div>
                  <div className="text-color-red">
                    {user?.shopifyDetails?.email || ""}
                  </div>
                </div>
                {!!user?.details.phoneNumber && (
                  <div className="right-section">
                    <div className="mobile-number">
                      +91-{user?.details.phoneNumber}
                    </div>{" "}
                    {!paymentPage ? (
                      <button
                        type="button"
                        aria-label="edit_number"
                        onClick={handleChangeNumber}
                        className="edit_button"
                      >
                        <img src={Edit} alt="" />
                      </button>
                    ) : (
                      <div>&nbsp;</div>
                    )}
                  </div>
                )}
              </div>
              <div className="line" />
            </>
          )}
        </div>
        {!orderPlaced && (
          <div className="links">
            <ul>
              <li>
                <NavLink
                  className={() =>
                    location.pathname.includes("login") ? "active" : "active2"
                  }
                  // to='/login'
                  onClick={(event) => event.preventDefault()}
                >
                  Mobile
                </NavLink>
                <span className="mobile-section-under">
                  ...................
                </span>
              </li>
              <li>
                <NavLink
                  className={() =>
                    location.pathname.includes("address") ? "active" : "active2"
                  }
                  onClick={(event) => event.preventDefault()}
                >
                  Address
                </NavLink>
                <span className="mobile-section-under">
                  ...................
                </span>
              </li>
              <li>
                <NavLink
                  className={() => (isPaymentPage ? "active" : "active3")}
                  onClick={(event) => event.preventDefault()}
                >
                  Payment
                </NavLink>
              </li>
            </ul>
          </div>
        )}
        <Outlet />
      </div>
      <div
        className={`split right ${mobileView.showOrderDetails ? "open_details" : ""}`}
      >
        <Cart />
      </div>
    </div>
  );
}
export default Main;
